import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PrimaryPclsUsage } from "../../../../../../../Wrap/Models/Domains/Drawdown/PrimaryPclsUsage";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface ITaxYearProps extends IProcessComponentProps {
    data: PrimaryPclsUsage;
    excludeYears: number[];
}

interface ITaxYearState {}

export class TaxYear extends ProcessComponent<ITaxYearProps, ITaxYearState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getOptions = (currYear: number, fromYear: number, excludeYears: number[], renderYear: number): number[] => {
        const options = [];
        while (fromYear <= currYear) {
            if (fromYear == renderYear || !excludeYears.includes(fromYear)) {
                options.push(fromYear);
            }
            fromYear = fromYear + 1;
        }
        return options;
    };

    public render(): JSX.Element {
        const { data, excludeYears, onChange } = this.props;
        const currYear = new Date().getFullYear();
        const fromYear = 2006;

        return (
            <div className="row">
                <div className="col-3">
                    <SelectEditor
                        onChange={(v) =>
                            onChange({
                                Year: v,
                            })
                        }
                        options={this.getOptions(currYear, fromYear, excludeYears, data.Year)}
                        getText={(o) => `${o}/${o + 1}`}
                        selected={data.Year}
                        required="Please select a tax year. "
                        placeholder="Please select"
                    />
                </div>
                <div className="col-4">
                    <MoneyTextBoxEditor
                        currency={CurrencyCode.GBP}
                        value={data.Amount?.Amount}
                        onChange={(v) =>
                            onChange({
                                Amount: { Amount: v, Currency: CurrencyCode.GBP },
                            })
                        }
                        required={"Please enter a value for the amount taken."}
                    />
                </div>
            </div>
        );
    }
}
